var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificacionesnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2329 15.5385V16.2308C11.2329 16.9652 10.9458 17.6696 10.4348 18.1889C9.92372 18.7082 9.23062 19 8.50791 19C7.78521 19 7.0921 18.7082 6.58107 18.1889C6.07004 17.6696 5.78295 16.9652 5.78295 16.2308V15.5385M15.8176 14.1292C14.7242 12.7692 13.9523 12.0769 13.9523 8.32764C13.9523 4.89423 12.2271 3.67101 10.8071 3.07692C10.6185 2.99817 10.4409 2.81731 10.3835 2.62043C10.1344 1.75894 9.4361 1 8.50791 1C7.57972 1 6.88103 1.75938 6.6345 2.6213C6.57702 2.82034 6.39947 2.99817 6.21086 3.07692C4.78919 3.67188 3.06565 4.89077 3.06565 8.32764C3.06352 12.0769 2.29159 12.7692 1.1982 14.1292C0.745177 14.6925 1.142 15.5385 1.93437 15.5385H15.0857C15.8738 15.5385 16.2681 14.69 15.8176 14.1292Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificacionesnew);
export default __webpack_public_path__ + "static/media/notificaciones new.c907a033c69e5252a865bc8d2fb630c2.svg";
export { ForwardRef as ReactComponent };